import FormikCheckboxArray, {CheckboxArrayProps} from 'components/inputs/FormikCheckboxArray';
import React from 'react';

const RolePrivileges = ({
   prefix,
   resourceTypes,
   labels,
   disabled,
}: {
   prefix?: string;
   resourceTypes: CheckboxArrayProps['options'];
   labels: CheckboxArrayProps['labels'];
   disabled?: boolean;
}) => {
   return resourceTypes && prefix ? (
      <FormikCheckboxArray
         key={prefix}
         options={resourceTypes as string[]}
         name={prefix}
         labels={labels}
         disabled={disabled}
      />
   ) : null;

   // return (
   //    <div>
   //       {role &&
   //          map(role.resources, (p, key) => (
   //             <div key={role.name + key}>
   //                <FormikCheckbox name={`${prefix}.${key}`} label={key} />
   //             </div>
   //          ))}
   //    </div>
   // );
};

export default RolePrivileges;
